import { utc } from "PFCore/helpers/date";
import { useDateFormatter } from "PFCore/hooks";
import { useCallback } from "react";

type UseCalculateTotalHoursReturn = {
  calculateTotalHours: (startDate: string, endDate: string) => number;
};

export const useCalculateTotalHours = (): UseCalculateTotalHoursReturn => {
  const { formatISODate } = useDateFormatter();

  const calculateTotalHours = useCallback(
    (startDate: string, endDate: string) => {
      const daysCount = utc(formatISODate(utc(endDate))).diff(utc(formatISODate(utc(startDate))), "days") + 1;
      return daysCount * 24;
    },
    [formatISODate]
  );

  return {
    calculateTotalHours
  };
};
